import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

export default function Avantage() {
  const { t } = useTranslation();

  const avantages = [
    { title: t("avantage.web") },
    { title: t("avantage.infog") },
    { title: t("avantage.it") },
    { title: t("avantage.cloud") },
    { title: t("avantage.social") },
    { title: t("avantage.design") },
    { title: t("avantage.photo") },
  ];
  useEffect(() => {
    ScrollTrigger.create({
      trigger: ".avantage-card:first-child",
      start: () => "center center",
      endTrigger: ".avantage-card:last-child",
      end: () => "center center",
      pin: ".avantage-side",
      scrub: true,
      markers: false,
    });
  }, []);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const cards = gsap.utils.toArray(".avantage-card");

      cards.forEach((card, index) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: card,
            start: "top-=40 60%",
            end: "bottom+=40 40%",
            scrub: true,
            markers: false,
          },
        });

        tl.fromTo(
          card,
          {
            y: 20,
            opacity: 0.6,
            filter: "blur(15px)",
            duration: 0.5,
          },
          {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
          }
        );

        tl.to(card, {
          y: 0,
          opacity: 1,
          filter: "blur(0px)",
          duration: 0.5,
        });

        tl.to(card, {
          y: -20,
          opacity: 0.6,
          filter: "blur(15px)",
        });
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="avantage">
      <div className="avantage-side">{t("avantage.title")}</div>
      <div className="avantage-line">
        {avantages.map((avantage, index) => (
          <div className="avantage-card" key={index}>
            <h2 className="avantage-card-title">{avantage.title}</h2>
          </div>
        ))}
      </div>
    </div>
  );
}
